:host {
    display: block;
  }